module.exports = __webpack_public_path__ + "img/sld_annunciator.b3f61535.svg";